<template>
  <div class="ground-station-heartbeat-backdrop" :class="{ online, compact }" aria-hidden="true">
    <div class="heartbeat-grid"></div>
    <div class="heartbeat-particles">
      <i v-for="index in particleCount" :key="index"></i>
    </div>
    <div class="heartbeat-monitor">
      <GroundStationHeartbeatTrace v-if="espOnline" :tone="heartbeatTone" :pulse-key="pulseKey" :compact="compact" />
    </div>
  </div>
</template>

<script>
import GroundStationHeartbeatTrace from './GroundStationHeartbeatTrace'

export default {
  name: 'GroundStationHeartbeatBackdrop',
  components: { GroundStationHeartbeatTrace },
  props: {
    online: { type: Boolean, default: false },
    espOnline: { type: Boolean, default: false },
    heartbeatTone: { type: String, default: 'muted' },
    pulseKey: { type: [Number, String], default: '' },
    compact: { type: Boolean, default: false }
  },
  computed: {
    particleCount () { return this.compact ? 4 : 9 }
  }
}
</script>

<style lang="scss" scoped>
.ground-station-heartbeat-backdrop {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.heartbeat-grid {
  position: absolute;
  inset: 0;
  opacity: .3;
  background-image: linear-gradient(rgba(var(--ui-text-secondary-rgb), .2) 1px, transparent 1px), linear-gradient(90deg, rgba(var(--ui-text-secondary-rgb), .2) 1px, transparent 1px);
  background-size: 15px 15px;
  animation: fleet-heartbeat-grid 4s linear infinite;
}

.online .heartbeat-grid {
  background-image: linear-gradient(rgba(var(--ui-color-primary-rgb), .2) 1px, transparent 1px), linear-gradient(90deg, rgba(var(--ui-color-primary-rgb), .2) 1px, transparent 1px);
}

.heartbeat-particles { position: absolute; inset: 0; overflow: hidden; }
.heartbeat-particles i { width: 2px; height: 2px; position: absolute; right: -10px; border-radius: 50%; background: rgba(var(--ui-text-regular-rgb), .68); box-shadow: 0 0 4px rgba(var(--ui-text-secondary-rgb), .48); animation: fleet-heartbeat-particle 6s linear infinite; }
.heartbeat-particles i::after { content: ''; width: 12px; height: 1px; position: absolute; top: 1px; left: 2px; background: linear-gradient(90deg, rgba(var(--ui-text-secondary-rgb), .32), transparent); }
.online .heartbeat-particles i { background: rgba(var(--ui-color-primary-rgb), .82); box-shadow: 0 0 5px rgba(var(--ui-color-primary-rgb), .72); }
.online .heartbeat-particles i::after { background: linear-gradient(90deg, rgba(var(--ui-color-primary-rgb), .42), transparent); }
.heartbeat-particles i:nth-child(1) { top: 18%; animation-delay: -1.1s; animation-duration: 5.2s; }
.heartbeat-particles i:nth-child(2) { top: 38%; animation-delay: -3.8s; animation-duration: 8.2s; }
.heartbeat-particles i:nth-child(3) { top: 64%; animation-delay: -2.4s; animation-duration: 6.4s; }
.heartbeat-particles i:nth-child(4) { top: 82%; animation-delay: -5.2s; animation-duration: 9.2s; }
.heartbeat-particles i:nth-child(5) { top: 26%; animation-delay: -.4s; animation-duration: 6.8s; }
.heartbeat-particles i:nth-child(6) { top: 52%; animation-delay: -6.2s; animation-duration: 10.4s; }
.heartbeat-particles i:nth-child(7) { top: 72%; animation-delay: -4.6s; animation-duration: 5.7s; }
.heartbeat-particles i:nth-child(8) { top: 44%; animation-delay: -2.9s; animation-duration: 8.8s; }
.heartbeat-particles i:nth-child(9) { top: 88%; animation-delay: -7.1s; animation-duration: 7.5s; }

.heartbeat-monitor { height: 40px; position: absolute; top: var(--gs-heartbeat-line-top, 50%); right: 0; left: 0; overflow: hidden; transform: translateY(-50%); }
.compact .heartbeat-grid { opacity: .2; background-size: 13px 13px; }
.compact .heartbeat-particles, .compact .heartbeat-monitor { opacity: .42; }

@keyframes fleet-heartbeat-grid { to { background-position: -15px 0, -15px 0; } }
@keyframes fleet-heartbeat-particle { 0% { opacity: 0; transform: translateX(0); } 12% { opacity: .8; } 100% { opacity: 0; transform: translateX(-290px); } }

@media (prefers-reduced-motion: reduce) {
  .heartbeat-grid, .heartbeat-particles i { animation: none !important; }
}
</style>
